import fetchHelper from 'utils/fetchHelper';
import { REQUEST_CHARGES, RECEIVE_CHARGES, ERROR_CHARGES } from './constants';

interface Charge {
  id: number;
  name: string;
  allow_opt_out: boolean;
  charge_rule: string | null;
  charge_rule_value: number | null;
  service_fulfilment_methods: any[];
  menu_types: any[];
}

const requestCharges = () => ({
  type: REQUEST_CHARGES,
});

const receiveCharges = (charges: Charge[]) => ({
  type: RECEIVE_CHARGES,
  charges,
  receivedAt: Date.now(),
});

const errorCharges = (error: any) => ({
  type: ERROR_CHARGES,
  error,
});

export const fetchCharges = () => (dispatch: any) => {
  dispatch(requestCharges());

  const success = (res: any) => {
    if (res.data) {
      const transformedCharges = res.data
        .filter((charge: any) => charge.enabled)
        .map((charge: any) => ({
          id: charge.id,
          name: charge.name,
          allow_opt_out: charge.allow_opt_out,
          charge_rule: charge.charge_rule,
          charge_rule_value: charge.charge_rule_value,
          service_fulfilment_methods: charge.service_fulfilment_methods || [],
          menu_types: charge.menu_types || [],
        }));
      dispatch(receiveCharges(transformedCharges));
    }
  };

  const fail = (error: any) => {
    dispatch(errorCharges(error));
  };

  return fetchHelper(`/api/charges`, 'GET', null, success, fail);
};
